import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (password !== confirm) { toast.error("Passwords do not match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset — please log in");
      nav("/login");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to reset");
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-6 py-16">
      <div className="overline text-safety">Reset password</div>
      <h1 className="mt-2 font-display font-black text-4xl tracking-tighter text-forest">Set a new password</h1>
      <form onSubmit={submit} className="mt-8 border border-border bg-white p-8 space-y-5">
        <div>
          <div className="overline text-muted-foreground mb-2">Reset token</div>
          <Input required value={token} onChange={(e) => setToken(e.target.value)} data-testid="reset-token" className="rounded-none h-12 font-mono text-xs" />
        </div>
        <div>
          <div className="overline text-muted-foreground mb-2">New password</div>
          <Input required type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" className="rounded-none h-12" />
        </div>
        <div>
          <div className="overline text-muted-foreground mb-2">Confirm new password</div>
          <Input required type="password" minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" className="rounded-none h-12" />
        </div>
        <Button type="submit" disabled={loading} data-testid="reset-submit" className="w-full rounded-none bg-forest hover:bg-forest-800 text-white h-12">
          {loading ? "Resetting…" : "Reset password"}
        </Button>
      </form>
      <div className="mt-6 text-sm text-center">
        <Link to="/login" className="text-forest hover:text-safety">← Back to log in</Link>
      </div>
    </div>
  );
}
